import React from "react";
import { AlertTriangle, CheckCircle2, Monitor } from "lucide-react";
import "./install-guide.css";

export default function InstallGuide() {
  return (
    <div className="ig-root">

      {/* ── Header ───────────────────────────────────────── */}
      <header className="ig-header">
        <div className="ig-header-glow" />
        <div className="ig-header-top">
          <span className="ig-tag">
            <Monitor size={10} /> Installation
          </span>
          <div className="ig-meta">
            <span>10 min</span><span className="ig-dot" />
            <span>Windows 10 &amp; 11</span>
          </div>
        </div>
        <h1 className="ig-title">Device Setup &amp; Installation Guide</h1>
        <p className="ig-lead">Follow these steps to get a Windows computer live on your VisuN AI dashboard.</p>
      </header>

      {/* ── Steps ────────────────────────────────────────── */}
      <section className="ig-section">
        <p className="ig-section-eyebrow">Installation steps</p>

        <div className="ig-steps">

          <div className="ig-step">
            <div className="ig-step-num">1</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Open the Downloads page</h3>
              <p className="ig-step-text">Click <strong>Download</strong> in the sidebar. You'll see the Configuration and Deployment panels.</p>
              <img className="ig-img" src="/step1-download-page.png" alt="VisuN AI Downloads page" />
            </div>
          </div>

          <div className="ig-step">
            <div className="ig-step-num">2</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Enter the device username</h3>
              <p className="ig-step-text">Type the Windows username of the computer you're setting up in the <strong>User Name / Identifier</strong> field.</p>
              <img className="ig-img" src="/step2-enter-username.png" alt="Username field" />
            </div>
          </div>

          <div className="ig-step">
            <div className="ig-step-num">3</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Click One-Click Deploy</h3>
              <p className="ig-step-text">Hit <strong>One-Click Deploy</strong> — this downloads all 3 files at once.</p>
            </div>
          </div>

          <div className="ig-step">
            <div className="ig-step-num">4</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Allow multiple downloads in your browser</h3>
              <p className="ig-step-text">A browser prompt will appear asking to download multiple files. Click <strong>Allow</strong>.</p>
              <div className="ig-notice">
                <AlertTriangle size={13} />
                <span>Missed the prompt? Refresh the page and click Deploy again.</span>
              </div>
              <img className="ig-img" src="/step4-browser-permission.png" alt="Browser permission popup" />
            </div>
          </div>

          <div className="ig-step">
            <div className="ig-step-num">5</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Confirm all 3 files are downloaded</h3>
              <p className="ig-step-text">Open your <strong>Downloads</strong> folder and verify all 3 files are there before continuing.</p>
              <img className="ig-img" src="/step5-files-downloaded.png" alt="Downloads folder with 3 files" />
            </div>
          </div>

          <div className="ig-step">
            <div className="ig-step-num">6</div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">Run VisuN AI-Installer.exe</h3>
              <p className="ig-step-text">Double-click the installer. Windows SmartScreen will warn you — this is expected. Follow the two steps below.</p>
              <div className="ig-substeps">
                <div className="ig-substep">
                  <div className="ig-substep-header">
                    <span className="ig-substep-badge">Step A</span>
                    <span>Click <strong>More info</strong></span>
                  </div>
                  <img className="ig-img" src="/step6a-smartscreen.png" alt="SmartScreen — click More info" />
                </div>
                <div className="ig-substep">
                  <div className="ig-substep-header">
                    <span className="ig-substep-badge">Step B</span>
                    <span>Click <strong>Run anyway</strong></span>
                  </div>
                  <img className="ig-img" src="/step6b-run-anyway.png" alt="SmartScreen — Run anyway" />
                </div>
              </div>
            </div>
          </div>

          <div className="ig-step ig-step--done">
            <div className="ig-step-num ig-step-num--done"><CheckCircle2 size={15} /></div>
            <div className="ig-step-body">
              <h3 className="ig-step-title">You're all set</h3>
              <p className="ig-step-text">The device will appear in your VisuN AI dashboard within a few minutes.</p>
              <img className="ig-img" src="/result.png" alt="Device live on VisuN AI dashboard" />
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}
